import React, { useEffect, useState } from 'react'
import { Button, Flex, Input, Spinner, Text } from '@Common/Components'
import moment from 'moment'
import { Checkbox } from 'primereact/checkbox'
import { useQuery } from '@tanstack/react-query'
import { getUrlParams } from '@Common/Services'
import { checkRegexErr, createQuote, fetchAgency, getDisabledDays, GRID, GRID_SMALL } from './Functions'
import { useWindowSize } from 'react-use'

export const QuoteForm = ({ formData: [formData, setFormData] }) => {
  const agencyCode = getUrlParams('agency')
  const { isSuccess, data: agency = {} } = useQuery(['agencyInfo', agencyCode], fetchAgency(agencyCode), { enabled: !!agencyCode })
  const [disabledDates, setDisabledDates] = useState([])
  const [privacyAccepted, setPrivacyAccepted] = useState(false)
  const [checkError, setCheckError] = useState(false)
  const { width: pageWidth } = useWindowSize()

  useEffect(() => setDisabledDates(getDisabledDays(formData?.fromDate)), [formData?.fromDate])

  const inputProps = (id, placeholder, required) => ({
    value: formData?.[id],
    placeholder,
    id,
    onChange: (e) => setFormData({ ...formData, [id]: e?.[id] }),
    style: { gridArea: id, borderRadius: 10, height: 50, paddingLeft: 25 },
    error: !!(checkError && ((!formData?.[id] && required) || checkRegexErr(id, formData?.[id])))
  })

  const inputPropsDate = (id, placeholder, required) => ({
    placeholder,
    monthNavigator: true,
    yearNavigator: true,
    yearRange: '2010:2060',
    onChange: (e) => setFormData({ ...formData, [id]: e?.[id] }),
    date: true,
    id,
    value: formData?.[id],
    style: { gridArea: id, borderRadius: 10, height: 50, paddingLeft: 0, marginLeft: 0 },
    error: !!(checkError && !formData?.[id] && required)
  })

  const sendRequest = async () => {
    setCheckError(true)
    if (!privacyAccepted) return window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Accettare privacy per procedere!' })
    const res = await createQuote({ ...formData, agency: agency?._id })
    setCheckError(false)
    res && setFormData({})
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex as style={{ padding: '20px 40px' }}>
      <Text value='Richiedi un preventivo' title bold size={25} />
      <Text value='Informazioni di viaggio' upCase title bold style={{ marginTop: 20 }} />
      <div style={{ display: 'grid', gridTemplateAreas: pageWidth > 450 ? GRID[0] : GRID_SMALL[0], gridGap: '9px 9px', width: '100%', marginTop: 15 }}>
        <Input {...inputProps('fromLocation', 'Da dove vuoi partire?', true)} />
        <Input {...inputProps('toLocation', 'Dove vuoi andare?', true)} />
        <Input {...inputPropsDate('fromDate', 'Data partenza:', true)} minDate={moment().toDate()} />
        <Input {...inputPropsDate('toDate', 'Data ritorno:', true)} minDate={moment().toDate()} disabledDates={disabledDates} />
      </div>
      <Text value='Viaggiatori' upCase title bold style={{ marginTop: 20 }} />
      <div style={{ display: 'grid', gridTemplateAreas: pageWidth > 450 ? GRID[1] : GRID_SMALL[1], gridGap: '9px 9px', width: '100%', marginTop: 15 }}>
        <Input {...inputProps('numAdults', 'N. Adulti', true)} keyfilter='num' />
        <Input {...inputProps('numChildren', 'N. Bambini', false)} keyfilter='num' />
        <Input {...inputProps('childrenAge', 'Età Bambini')} />
        <Input {...inputProps('clientName', 'Nome', true)} />
        <Input {...inputProps('clientLastName', 'Cognome', true)} />
        <Input {...inputProps('clientEmail', 'Email', true)} />
        <Input {...inputProps('user', 'Cellulare:', true)} />
      </div>
      <Text value='Note' upCase title bold style={{ marginTop: 20 }} />
      <div style={{ width: '100%', marginTop: 15 }}>
        <Input {...inputProps('userNotes', 'Note e richieste servizio')} multiline />
      </div>
      <Flex fw js row style={{ marginTop: 15 }}>
        <Checkbox onChange={e => setPrivacyAccepted(e.checked)} checked={privacyAccepted} style={{ marginRight: 10 }} />
        <div style={{ fontFamily: '\'Source Sans Pro\', sans-serif', color: '#32324e', fontSize: 15, fontWeight: 'normal' }}>
          Ho preso visione dell’<a href='https://www.siapcn.it/privacy-policy/' target='_blank' rel='noopener noreferrer'>informativa privacy</a> e acconsento al trattamento dei dati
        </div>
      </Flex>
      <Flex fw>
        <Button label='Inoltra richiesta' icon='send' style={{ height: 40, borderRadius: 10, marginTop: 15 }} onClick={sendRequest} />
      </Flex>
    </Flex>
  )
}
